/**
 * Generate a review card
 * @param {string} body
 * @param {string} date
 * @param {number} id
 * @param {string} productHandle
 * @param {string} image
 * @param {string} productTitle
 * @param {number} rating
 * @param {string} name
 * @param {string} title
 * @param {string} price
 */
function generateUIReviewCard(
  body,
  date,
  id,
  productHandle,
  image,
  productTitle,
  rating,
  name,
  title,
  price
) {
  const wrapper = document.querySelector('.reviews-slider__main');

  if (!wrapper) return;

  const ratingEl = window.theme.generateReviewStars(rating);
  const formattedDate = new Date(date).toLocaleDateString('en-GB');

  const fragment = document.createDocumentFragment();
  const div = document.createElement('div');
  div.className = 'reviews-slider__slide';
  div.innerHTML = `
    <!-- Card Image -->
    <a href="products/${productHandle}" class="reviews-slider__card-link">
      <img src="${image?.src}" alt="${title}" width="235" height="164">
    </a>
    <!-- Reviewer Name -->
    <h3 class="reviews-slider__card-reviewer">
      ${window.theme.abbreviateName(name)}
    </h3>
    
    <div class="reviews-slider__card-rating-wrapper">
      <!-- Review Stars -->
      <div class="reviews-slider__card-rating">
        ${ratingEl}  
      </div>
      <span class="reviews-slider__card-separator"> | </span>
      <!-- Review Date -->
      <p class="reviews-slider__card-date">
        ${formattedDate}
      </p>
    </div>
    
    <!-- Review Text -->
    <p class="reviews-slider__card-text">${body}</p>
    
    
    <a href="products/${productHandle}" class="reviews-slider__card-link">
      <div class="reviews-slider__card-footer">
        <!-- Product Title -->
        <span class="reviews-slider__card-title">${productTitle}</span>

        <!-- Product Price -->
        <p class="reviews-slider__card-price">€${price.split('.').slice(0, 1)}</p>
      </div>
    </a>
  `;

  fragment.appendChild(div);
  wrapper.appendChild(fragment);
}

/**
 * Fetch the data and render the review card
 * @returns {Promise<void>}
 */
async function renderReviewsCards() {
  const totalReviewsCountEl = document.querySelector('.reviews-slider__total-count');
  const totalReviewsCountNumber = document.querySelector('.reviews-slider__total-number');

  if (!totalReviewsCountEl) return;

  const results = await fetch(`/apps/judgeme-proxy`);
  const {
    reviews,
    reviewsCount: {count},
  } = await results.json();
  const publishedReviews = reviews.filter((review) => review.published);

  if (totalReviewsCountNumber) totalReviewsCountNumber.textContent = count;
  else totalReviewsCountEl.textContent = `from ${count} reviews`;

  if (results.status !== 200 || !publishedReviews?.length || publishedReviews?.length === 0) {
    document.querySelector('.reviews-slider').style.display = 'none';
  }

  publishedReviews?.forEach(
    ({
      product_external_id: productExternalId,
      body,
      created_at: createdAt,
      id,
      product_handle: productHandle,
      product_image: productImage,
      product_title: productTitle,
      rating,
      reviewer: {name},
      title,
      variants,
    }) => {
      // Filter out "broken" product from API
      if (productExternalId === 0) return;

      generateUIReviewCard(
        body,
        createdAt,
        id,
        productHandle,
        productImage,
        productTitle,
        rating,
        name,
        title,
        variants[0].price
      );
    }
  );
}

/**
 * Initialize the slider and handle the custom buttons
 * @returns {Promise<void>}
 */
async function initReviewsSlider() {
  const skeleton = document.getElementById('reviews-slider-skeleton');
  const prevBtn = document.querySelector('#sl-reviews-slider-arrows .arrow-previous');
  const nextBtn = document.querySelector('#sl-reviews-slider-arrows .arrow-next');
  const mql = window.matchMedia('(min-width: 769px)').matches;

  if (!(prevBtn && nextBtn)) return;

  // Render the cards
  await renderReviewsCards();

  // Init the slider with options
  const slider = new Flickity('.reviews-slider__main', {
    groupCells: mql ? 4 : 1,
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    cellAlign: 'left',
    on: {
      ready() {
        this.element.classList.add('ready');
        skeleton.style.display = 'none';
        this.resize();
      },
    },
  });

  // Custom previous slide button
  prevBtn.addEventListener('click', () => {
    slider.previous();
  });

  // Custom next slide button
  nextBtn.addEventListener('click', () => {
    slider.next();
  });

  // Disable the next/prev button if first or last slide
  slider.on('select', (index) => {
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === slider.slides.length - 1;
  });
}

document.addEventListener('DOMContentLoaded', async () => {
  initReviewsSlider();
});
